module.exports = __webpack_public_path__ + "img/user-19.263a51b7.svg";